/**
 * Class can be used to add dynamic behavior to buttons
 * An example usage would be - set button as loading when an ajax request is triggered, reset it if ajax request fails.
 */
export default class ButtonState {
	/**
	 * Initialize a button with state
	 *
	 * @param $button
	 * @returns {ButtonState}
	 */
	constructor($button, config) {
		this.$button = $button;

		this.config = {
			childTextContainer: '.ellipse__button_text',
			preserveClasses: true,
		};

		/**
		 * Allow config overriding.
		 */
		if (typeof config !== 'undefined') {
			this.config = Object.assign(this.config, config);
		}

		this.state = {
			initialText: this.getInitialText(),
			initialClass: this.getInitialClasses(),
		};

		return this;
	}

	/**
	 * Get initial button text
	 *
	 * @return {*}
	 */
	getInitialText() {
		if (this.$button.find(this.config.childTextContainer).length) {
			return this.$button.find(this.config.childTextContainer).text();
		} else {
			return this.$button.text();
		}
	}

	/**
	 * Get initial classes
	 * @return string
	 */
	getInitialClasses() {
		return this.$button.attr('class');
	}

	/**
	 * Reload button state
	 */
	reloadState() {
		this.state.initialText = this.getInitialText();
		this.state.initialClass = this.getInitialText();
	}

	/**
	 * Set button state as loading
	 *
	 * @param text - Optional, Button text to be set while in loading state.
	 *              If text param is not provided, script will look for text in button's data-loading-text attribute,
	 *              If data-loading-text attribute is not set, text will not be changed.
	 *
	 */
	loading(text) {
		if (typeof text === 'undefined' && this.$button.attr('data-loading-text') !== '') {
			text = this.$button.attr('data-loading-text');
		}

		if (typeof text !== 'undefined') {
			if (this.$button.find(this.config.childTextContainer).length) {
				this.$button.find(this.config.childTextContainer).text(text);
			} else {
				this.$button.text(text);
			}
		}

		this.$button.addClass('disabled');
	}

	/**
	 * Reset button to its initial state
	 */
	reset() {
		if (this.config.preserveClasses) {
			this.$button.attr('class', this.state.initialClass);
		} else {
			this.$button.removeClass('disabled');
		}

		if (this.$button.find(this.config.childTextContainer).length) {
			this.$button.find(this.config.childTextContainer).text(this.state.initialText);
		} else {
			this.$button.text(this.state.initialText);
		}
	}
}
